/*
 * {
  "region": "us-east-2",
  "userPool": "us-east-2_SGoFq76ax",
  "userPoolBaseUri": "https://mrtggrp.auth.us-east-2.amazoncognito.com",
  "clientId": "1uomjp5vb6fk59vnavr67j6957",
  "callbackUri": "http://localhost:3000/callback",
  "signoutUri": "http://localhost:3000/presentation",
  "tokenScopes": [
    "openid",
    "email",
    "profile",
    "http://localhost:3000/authapp.all"
  ],
  "apiUri": "https://cognito-demo-api.arronharden.com"
}
 */



 const dev = {
     apiGateway: {

        "getSearchDataUrl": "https://api.mtsgrp.net/trexsearch",
         "searchUrl": "https://api.mtsgrp.net/search",
        "searchOrderUrl": "https://api.mtsgrp.net/searchorder",
        "searchNoteUrl": "https://api.mtsgrp.net/searchordernote",
        "getDocUrl": "https://api.mtsgrp.net/getdoc",
         "updateOrderUrl": "https://api.mtsgrp.net/updateorder",
         "submitUrl": "https://api.mtsgrp.net/ordersubmit",
         "updatePropertyReport": "https://api.mtsgrp.net/propertyreportsubmit",
         "getAppDataUrl": "https://api.mtsgrp.net/trexgetdata",
         "PropertyReport": "https://api.mtsgrp.net/updateorder"
         
     },
     cognito: {
         "region": "us-east-2",
         "userPool": "us-east-2_SGoFq76ax",
         "userPoolBaseUri": "https://mrtggrp.auth.us-east-2.amazoncognito.com",
         "clientId": "1uomjp5vb6fk59vnavr67j6957",
         "callbackUri": "http://localhost:3000/callback",
         "signoutUri": "http://localhost:3000/presentation",
         "tokenScopes": [
             "openid",
             "email",
             "profile",
             "http://localhost:3000/authapp.all"
         ],
         "apiUri": "https://cognito-demo-api.arronharden.com"
     }
 };

const prod = {
    apiGateway: {
        "searchUrl": "https://prodapp.mtsgrp.net/search",
        "searchOrderUrl": "https://prodapp.mtsgrp.net/searchorder",
        "searchNoteUrl": "https://prodapp.mtsgrp.net/searchordernote",
        "getDocUrl": "https://prodapp.mtsgrp.net/getdoc",
        "getAppDataUrl": "https://prodapp.mtsgrp.net/trexgetdata",
        "updateOrderUrl": "https://prodapp.mtsgrp.net/updateorder",
        "submitUrl": "https://prodapp.mtsgrp.net/ordersubmit",
        "updatePropertyReport": "https://prodapp.mtsgrp.net/propertyreportsubmit"
    },
    cognito: {
        "region": "us-east-2",
        "userPool": "us-east-2_VK0aMeftZ",
        "userPoolBaseUri": "https://auth.mtsgrp.net",
        "clientId": "7a5al8k5gjvr9ncdn2cckk9sd6",
        "callbackUri": "https://store.mtsgrp.net/callback",
        "signoutUri": "https://store.mtsgrp.net/presentation",
        "tokenScopes": [
            "openid",
            "email",
            "profile",
            "https://store.mtsgrp.net/authapp.all"
        ],
        "apiUri": "https://cognito-demo-api.arronharden.com"
    }
};

// Default to dev if not set
//const config = process.env.REACT_APP_STAGE === 'prod'
 //   ? prod
   // : dev;
    const config  = prod;
export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...config
};